// @flow
import { combineReducers } from 'redux';
import orgs from './orgs';
import listings from './listings';
import search from './search';
import gradPrograms from './gradPrograms';
import idealistDayEvents from './idealistDayEvents';
import integrations from './integrations';
import type { Action as OrgAction } from '../../actions/orgDashboard/orgs';
import type { Action as ListingsAction } from '../../actions/orgDashboard/listings';
import type { Action as SearchAction } from '../../actions/orgDashboard/search';
import type { Action as GradProgramAction } from '../../actions/orgDashboard/gradPrograms';
import type { Action as IdealistDayEventAction } from '../../actions/orgDashboard/idealistDayEvents';
import type { Action as IntegrationsAction } from '../../actions/orgDashboard/integrations';

export default combineReducers<
  {
    orgs: typeof orgs,
    listings: typeof listings,
    search: typeof search,
    gradPrograms: typeof gradPrograms,
    idealistDayEvents: typeof idealistDayEvents,
    integrations: typeof integrations
  },
  | OrgAction
  | ListingsAction
  | SearchAction
  | GradProgramAction
  | IdealistDayEventAction
  | IntegrationsAction
>({
  orgs,
  listings,
  search,
  gradPrograms,
  idealistDayEvents,
  integrations
});
